import Flickity from 'flickity'
import './geschiedenis.scss'

document.addEventListener('DOMContentLoaded', () => {
    const blocks = document.querySelectorAll('.o-geschiedenis');
    if (!blocks.length) return;

    const getFlickityInstance = (el) => {
        if (!el) return null;

        const moduleInstance = Flickity?.data?.(el);
        if (moduleInstance) return moduleInstance;

        const globalInstance = window.Flickity?.data?.(el);
        return globalInstance || null;
    };

    blocks.forEach((historySlider) => {
        const mainEl = historySlider.querySelector('.o-geschiedenis__main');
        const navEl = historySlider.querySelector('.o-geschiedenis__nav');
        if (!mainEl || !navEl) return;

        const pause = () => {
            const mainF = getFlickityInstance(mainEl);
            const navF = getFlickityInstance(navEl);

            if (mainF?.pausePlayer) mainF.pausePlayer();
            if (navF?.pausePlayer) navF.pausePlayer();

            historySlider.classList.add('pauze');
        };

        const resume = () => {
            const mainF = getFlickityInstance(mainEl);
            const navF = getFlickityInstance(navEl);

            if (mainF?.unpausePlayer) mainF.unpausePlayer();
            if (navF?.unpausePlayer) navF.unpausePlayer();

            historySlider.classList.remove('pauze');
        };

        [mainEl, navEl].forEach((el) => {
            el.addEventListener('mouseenter', pause);
            el.addEventListener('mouseleave', resume);
            el.addEventListener('pointerenter', pause);
            el.addEventListener('pointerleave', resume);
        });
    });
});